<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">软件下载</div>
      </div>

      <img class="pwmat-trial-download-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-trial-download-container">

     <div class="pwmat-trial-download-content">
       <div class="pwmat-trial-download-content-title">
         <div class="pwmat-trial-download-content-title-text">MCLUSTER平台</div>
         <div class="pwmat-trial-download-line"></div>
       </div>

       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text">对于MCLUSTER平台，PWmat需要的依赖环境已经单独配置好，仅仅需要下载PWmat和对应的任务调度系统脚本。注意，这里仅提供最新版经过特殊优化的PWmat下载。（Warning：PWmat应用程序的名字可以修改为PWmat_XX，但是不要修改为其他的名字，比如“gousheng” ，这样可能会引起多个任务占用同一个GPU）</p>
       </div>

       <div>
         <table class="pwmat-trial-download-introduce-table">
           <tr class="pwmat-trial-download-introduce-th">
             <th class="pwmat-trial-download-introduce-text-th">CUDA版本</th>
             <th class="pwmat-trial-download-introduce-text-th">Intel MPI版本</th>
             <th class="pwmat-trial-download-introduce-text-th">PWmat版本</th>
             <th class="pwmat-trial-download-introduce-text-th">安装包</th>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" >
             <td class="pwmat-trial-download-introduce-text-td">8.0</td>
             <td class="pwmat-trial-download-introduce-text-td">2016</td>
             <td class="pwmat-trial-download-introduce-text-td">Latest</td>
             <td class="pwmat-trial-download-introduce-text-td"><a :href="MCLUSTER_DOWNLOAD+'cuda-8.0-cluster.zip'">MCLUSTER PWmat Latest CUDA8.0</a></td>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" >
             <td class="pwmat-trial-download-introduce-text-td">11.6</td>
             <td class="pwmat-trial-download-introduce-text-td">oneapi2022</td>
             <td class="pwmat-trial-download-introduce-text-td">Latest</td>
             <td class="pwmat-trial-download-introduce-text-td"><a :href="MCLUSTER_DOWNLOAD+'cuda-11.6-betacluster.zip'">MCLUSTER PWmat Latest CUDA11.6</a></td>
           </tr>
         </table>
       </div>

       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text">这里提供一个MCLUSTER计算任务提交脚本给用户参考</p>
         <pre class="pwmat-trial-download-pre">
#!/bin/bash
#PBS -N PWmat_4000
#PBS -l nodes=node1:ppn=4+node2:ppn=4
#PBS -l walltime=2:00:00
#PBS -q batch
#PBS -o PWmat.out
#PBS -e PWmat.err

ulimit -s unlimited
source /where/your/install/pwmat/pwmat.env #this line may vary according to where the PWmat installed

cd $PBS_O_WORKDIR
NP=`cat $PBS_NODEFILE | wc -l`
cat $PBS_NODEFILE < ./hosts

mpirun -np $NP --machinefile $PBS_NODEFILE -genv I_MPI_DEVICE rdma -env I_MPI_FALLBACK_DEVICE 0 -env I_MPI_DEBUG 0 PWmat
         </pre>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  import {MCLUSTER_DOWNLOAD} from "../../helpers/consts"

  export default {
    name: "companyIntroduce",
    data(){
      return {
        MCLUSTER_DOWNLOAD
      }
    },
    methods:{
      toPWmatUpdateFunc(){
        this.$router.push({ name: 'PWmatUpdateFunc'})
      }

    }
  }
</script>

<style scoped>
  .pwmat-trial-download-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-trial-download-background{
    margin-top: 70px;
  }
  .pwmat-trial-download-banner{
    overflow:hidden;
  }
  .pwmat-trial-download-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-trial-download-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-trial-download-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-trial-download-content-title{
    padding-top: 50px;
  }
  .pwmat-trial-download-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-trial-download-content-note-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 0px;
  }
  .pwmat-trial-download-content-info{
    margin-top: 40px;
  }
  .pwmat-trial-download-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-trial-download-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }

  .pwmat-trial-download-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .pwmat-trial-download-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .pwmat-trial-download-introduce-td{
    height: 45px;
  }
  .pwmat-trial-download-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .pwmat-trial-download-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .pwmat-trial-download-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding: 16px;
  }
  .pwmat-trial-download-info-a{
    cursor: pointer;
  }
  .pwmat-trial-download-info-a:hover,
  .pwmat-trial-download-info-a:active{
    text-decoration:underline;
  }
  .pwmat-trial-download-pre{
    background:rgba(73,145,201,0.1);
    padding: 24px 32px;
  }
  @media screen and (max-width:482px) {
    .pwmat-trial-download-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-trial-download-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-trial-download-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }

</style>
